import * as React from 'react';
import { PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@swyftx/aviary/atoms/Button';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Modal } from '@swyftx/aviary/atoms/Modal';
import { Body, BodyLink, Heading } from '@swyftx/aviary/atoms/Typography';
import { Cross } from '@swyftx/aviary/icons/outlined';
import { LoanHealthCarousel } from '@swyftx/features/loans/components/LoanHealth/EducationModal/LoanHealthCarousel';

import { Links } from '@shared/constants';

const LoanHealthEducationModal: React.FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);
  const { t } = useTranslation('loans');

  return (
    <Modal
      position='dynamic'
      className='w-full md:w-[900px]'
      onOpenChange={(o) => setOpen(o || false)}
      open={open}
      showCloseButton={false}
      triggerElement={children}
    >
      <FlexLayout className='flex-col md:flex-row'>
        <FlexLayout direction='column' justifyContent='space-between' className='w-full p-32 md:w-1/3'>
          <FlexLayout direction='column' spacing={24}>
            <Heading size='h3'>{t('loanHealth.educationModal.title')}</Heading>
            <Body color='secondary' className='whitespace-pre-wrap'>
              {t('loanHealth.educationModal.description')}
            </Body>
          </FlexLayout>
          <div className='pt-24'>
            <Body className='inline' color='secondary'>
              {t('loanHealth.educationModal.stillUnsure')}
            </Body>
            <BodyLink
              size='medium'
              //  TODO: replace with correct support article link
              href={Links.help.home}
              color='info'
              className='inline cursor-pointer underline underline-offset-2'
            >
              {t('loanHealth.educationModal.readSupport')}
            </BodyLink>
          </div>
        </FlexLayout>

        <div className='w-full border-t border-color-border-main bg-color-background-pageBG p-32 pt-8 md:w-2/3 md:border-l md:border-t-0'>
          <LoanHealthCarousel />
        </div>

        <Button
          onClick={() => {
            setOpen(false);
          }}
          variant='outlined'
          className='absolute right-24 top-24 z-10 bg-color-background-surface-primary md:bg-color-background-pageBG'
          layout='icon'
          leadingIcon={<Cross />}
          aria-label='Close'
        />
      </FlexLayout>
    </Modal>
  );
};

LoanHealthEducationModal.displayName = 'LoanHealthEducationModal';

export { LoanHealthEducationModal };
